var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('menu-item',{attrs:{"title":'Popular Streams',"closeTitle":'Close Popular Streams'},on:{"close-menu-item":function($event){return _vm.$emit('close-menu')}}},[_c('template',{slot:"content"},[_c('div',{staticClass:"menu-item-row no-scroll"},[_c('popular-streams')],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }